<template>
  <div class="footer">
    <div class="children">
      <div class="top">
        <!-- 简介版 -->
        <template v-if="isSimpleTemplate">
          <div class="left2" v-if="isSimpleTemplate">
            <div class="temp">{{ contact.title }}</div>
            <div class="temp">{{ contact.name }}</div>
            <div class="temp">{{ contact.phoneOrEmail }}</div>
          </div>
          <div class="center2">
            <div class="temp">{{ workAndRest.title }}</div>
            <div class="temp">{{ workAndRest.workTime }}</div>
            <div class="temp">{{ workAndRest.restTime }}</div>
          </div>
        </template>

        <!-- 复杂版 -->
        <template v-if="isComplexTemplate">
          <div class="left complex">
            <div class="title complex-title">
              <img class="complex__logo" :src="logo" alt="logo" />
              <span class="complex__slogan" :title="slogan">{{ slogan }}</span>
            </div>
            <div class="detail">
              {{ intro }}
            </div>
            <div class="address">
              <span>{{ address.title }}：</span>
              <span>{{ address.addressDetail }}</span>
            </div>
          </div>
          <div class="center">
            <div class="title">{{ phone.title }}：</div>
            <div class="phone">{{ phone.phoneDetail }}</div>
            <div class="email">
              <span>{{ email.title }}：</span>
              <span>{{ email.emailDetail }}</span>
            </div>
          </div>
          <div class="right">
            <div v-if="qrCodeA.isOpen === 1">
              <img :src="qrCodeA.qrCodeImgUrl" :alt="qrCodeA.title" />
              <p>{{ qrCodeA.title }}</p>
            </div>
            <div v-if="qrCodeB.isOpen === 1">
              <img :src="qrCodeB.qrCodeImgUrl" :alt="qrCodeB.title" />
              <p>{{ qrCodeB.title }}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    siteConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isSimpleTemplate({ siteConfig }) {
      return siteConfig.bottom?.template === 1;
    },
    isComplexTemplate({ siteConfig }) {
      return siteConfig.bottom?.template === 2;
    },
    logo({ siteConfig }) {
      return siteConfig.bottom?.logoImgUrl;
    },
    slogan({ siteConfig }) {
      return siteConfig.bottom?.slogan;
    },
    intro({ siteConfig }) {
      return siteConfig.bottom?.intro;
    },
    address({ siteConfig }) {
      return siteConfig.bottom?.address || {};
    },
    phone({ siteConfig }) {
      return siteConfig.bottom?.phone || {};
    },
    email({ siteConfig }) {
      return siteConfig.bottom?.email || {};
    },
    qrCodeA({ siteConfig }) {
      return siteConfig.bottom?.qrCodeA || {};
    },
    qrCodeB({ siteConfig }) {
      return siteConfig.bottom?.qrCodeB || {};
    },

    contact({ siteConfig }) {
      return siteConfig.bottom?.contact || {};
    },
    workAndRest({ siteConfig }) {
      return siteConfig.bottom?.workAndRest || {};
    },
  },
};
</script>

<style scoped lang="scss">
/* 临时样式 start */
.top .left2 {
  width: 440px;
}

.left2 .temp {
  font-size: 18px;
  color: #909399;
  line-height: 21px;
}

.center2 .temp {
  font-size: 18px;
  color: #909399;
  line-height: 21px;
}


/* 临时样式 end */

.right {
  width: 300px;
  display: flex;
  align-items: center;
}
.right div img {
  width: 126px;
  height: 126px;
}
.right div p {
  font-size: 18px;
  font-weight: bold;
  color: #909399;
  line-height: 25px;
  margin-top: 20px;
}

.right div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 20px;
}
.center .title {
  font-size: 18px;
  color: #909399;
  line-height: 21px;
}
.center .phone {
  font-size: 29px;
  font-weight: bold;
  color: #ffffff;
  line-height: 40px;
  margin: 43px 0;
}
.center .email {
  font-size: 18px;
  font-weight: 600;
  color: #909399;
  line-height: 25px;
}
.footer {
  padding-top: 40px;
  padding-bottom: 40px;
  // background: url("../assets/footer-bg.png");
  // background-position: center center;
  color: #fff;
  background: #171f30;
}
.children {
  width: 1178px;
  margin: 0 auto;
}

.top {
  display: flex;
  justify-content: space-between;
}
.top .left {
  width: 480px;
}
.left .title img {
  width: 100px;
}
.left .title {
  display: flex;
  font-size: 18px;
  color: #909399;
  line-height: 25px;
}
.detail {
  font-size: 18px;
  color: #909399;
  line-height: 25px;
  margin: 12px 0;
}
.address {
  font-size: 18px;
  color: #909399;
  line-height: 25px;
}

.complex {
  &-title {
    display: flex;
    align-items: center;
  }

  &__logo {
    display: block;
    width: 166px;
    height: 41px;
    margin-right: 12px;
    object-fit: cover;
  }

  &__slogan {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
